import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import { Switch } from "antd";

@autobind
/**
 *
 */
export default class Toggle extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.bool,
  };

  /**
   *
   * @return {XML}
   */
  get _component() {
    return <Switch checked={this.props.value} />;
  }
}
